var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-footer',{staticClass:"mt-8",attrs:{"padless":""}},[_c('v-col',{staticClass:"text-center text-caption blue lighten-2 white--text",attrs:{"cols":"12 "}},[_vm._v("© 2021 - TANAKA AI.")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }